import DbConfig from '../../../config/DbConfig.js'
import {getFansWithCustomById} from './friend.js'
import {formatTimeToYMDHms,socketType2DbType,trim} from '../../functions/Common.js'

// 根据粉丝id，获取聊天记录
export function getChatRecordListByFansId(fansId,firstId,callback){
	let db = DbConfig.connect()
	let sql = 'select * from yswl_chat_record where friend_id = '+ fansId
	if(firstId != 0){
		sql += ' and id < ' + firstId
	}
	sql += ' order by id desc limit 20'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

// 根据粉丝id，获取聊天记录
export function getChatRecordListByFansIdAndType(fansId,type,callback){
	if(type === undefined || type === ''){
		type = 'text'
	}
	let db = DbConfig.connect()
	let sql = 'select id,content from yswl_chat_record where friend_id = '+ fansId + ' and type = "' + type + '" order by id asc'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

// 保存聊天记录
export function saveReceiveMsg(data,callback){
	let db = DbConfig.connect()
	let id = data.recodeId
	let fromId = data.fromId
	let friendId = data.friendId
	let content = data.content
	let time = formatTimeToYMDHms(data.time)
	let toId = data.toId
	let type = socketType2DbType(data.type)
	let is_me = data.is_me === undefined ? 0 : data.is_me
	let is_send = data.is_send === undefined ? 1 : data.is_send
	let msgId = data.msgId === undefined ? null : parseInt(data.msgId)
	let other = data.other === undefined ? null : JSON.stringify(data.other)
	if(friendId !== undefined){
		getFansWithCustomById(friendId,(data2)=>{
			if(data2.fans_id === undefined){
				callback(false)
				return
			}
			let custom_id = data2.custom_id
			let from_name = data2.fans_wx_name
			let to_name = data2.custom_wx_name
			if(is_me !== 0){
				from_name = data2.custom_wx_name
				to_name = data2.fans_wx_name
			}
			let sql = 'insert into yswl_chat_record(id,custom_id,friend_id,from_id,to_id,content,from_name,to_name,send_time,is_me,is_read,is_send,type,msgId,other) values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)'
			db.transaction(tx=>{
				tx.executeSql(sql,[id,custom_id,friendId,fromId,toId,content,from_name,to_name,time,is_me,1,is_send,type,msgId,other],function(tx,data3){
					callback(data2)
				},function(tx,error){
					console.log(error)
					callback(false)
				})
			})
		})
	}else{
		callback(false)
	}
}

// 根据id，获取记录详情
export function getChatRecordById(id,callback){
	let db = DbConfig.connect()
	let sql = 'select * from yswl_chat_record where id = '+ id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let info = {}
			if(results.rows.length  > 0){
				info = results.rows[0]
			}
			callback(info)
		})
	})
}

// 根据id，更新聊天记录
export function updateChatRecordById(id,data,callback){
	let db = DbConfig.connect()
	let sql = 'update yswl_chat_record'
	if(data.is_send !== undefined){
		sql += ' set is_send = '+ data.is_send + ','
	}
	if(data.type !== undefined){
		sql += ' set type = "'+ data.type + '",'
	}
	if(data.msgId !== undefined){
		sql += ' msgId = "'+ data.msgId + '",'
	}
	if(data.content !== undefined){
		sql += ' content = "'+ data.content + '",'
	}
	sql = trim(sql,',')
	sql += ' where id = '+ id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			console.log(error)
			callback(false)
		})
	})
}

// 根据粉丝id，获取当前粉丝的聊天消息总数
export function getChatRecordCountByFansId(fansId,callback){
	let db = DbConfig.connect()
	let sql = 'select count(*) as total from yswl_chat_record where friend_id = '+ fansId
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let total = 0
			if(results.rows.length  > 0){
				total = results.rows[0].total
			}
			callback(total)
		})
	})
}

// 根据id，删除聊天记录
export function deleteChatRecordById(id,callback){
	let db = DbConfig.connect()
	let sql = 'delete from yswl_chat_record where id = '+ id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		})
	})
}

// 根据粉丝id，获取的记录数据，获取聊天记录
export function getChatRecordListByFansIdAndNum(fansId,num,callback){
	let db = DbConfig.connect()
	let sql = 'select * from yswl_chat_record where friend_id = '+ fansId + ' order by id desc limit '+num
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

// 根据客户id，手机端msgid，获取记录详情
export function getChatRecordByCidAndMsgid(custom_id,msgId,callback){
	let db = DbConfig.connect()
	let sql = 'select * from yswl_chat_record where custom_id = '+ custom_id + ' and msgId = '+ msgId
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let info = {}
			if(results.rows.length  > 0){
				info = results.rows[0]
			}
			callback(info)
		})
	})
}
